<template>
  <label class="selectable-checkpoint-line" :class="{ 'is-disabled': isDisabled }">
    <MinimalisticReadinessLevel :level="level" :disabled="isDisabled" />
    <span class="selectable-checkpoint-line__title">{{ title }}</span>
  </label>
</template>

<script setup>
import { computed } from 'vue';
import MinimalisticReadinessLevel from '@components/MinimalisticReadinessLevel/MinimalisticReadinessLevel.vue';
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  selected: {
    type: Boolean,
    default: false,
  },
  level: {
    type: String,
    default: 'apprentice',
  },
});

// Per request: when selected is false, component is disabled.
const isDisabled = computed(() => props.selected === false);
</script>

<style scoped>
.selectable-checkpoint-line {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  user-select: none;
  cursor: pointer;
}
.selectable-checkpoint-line.is-disabled {
  cursor: not-allowed;
}
.selectable-checkpoint-line__title {
  font-family: Inter;
  font-weight: 700;
  font-style: Bold;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
}
.selectable-checkpoint-line.is-disabled .selectable-checkpoint-line__title {
  color: #D0D5DD;
}
</style>